export default {"src":"/_next/static/media/dng_logo_white.9ac8e5c2.svg","height":36,"width":107,"blurWidth":0,"blurHeight":0};